@if (formConfig.label) {
  <div
    [class.re-inline-label]="formConfig.inlineLabel"
    [class.re-label-hint]="formConfig.labelHint">
    <label class="form-label" [class.re-disabled]="disabled" [for]="formConfig.id"
      >{{ formConfig.label }}
      @if (formConfig.mandatory) {
        <i class="fa-solid fa-asterisk"></i>
      }
    </label>
    @if (formConfig.labelHint) {
      <div [id]="hintId()">{{ formConfig.labelHint }}</div>
    }
  </div>
}
